import apiService from './apiService'

export const listUsers = (params) => apiService.get(URIS.users, params)
export const getUserById = (id) => apiService.get(URIS_D('user', id))
export const createUser = (data) => apiService.post(URIS.users, data)
export const updateUser = (id, data) => apiService.patch(URIS_D('user', id), data)

export const calculatePoints = (data) => apiService.post(URIS.publicCalculate, data)
export const calculateCash = (data) => apiService.post(URIS.publicCalculateCash, data)
export const calculateEncashablePoints = (data) => apiService.post(URIS.publicCalculateEncashable, data)
export const validateRedemption = (data) => apiService.post(URIS.publicValidateRedemption, data)

export const listPoints = (params) => apiService.get(URIS.points, { params })
export const getUserBalance = (userId) => apiService.get(URIS_D('userBalance', userId))
export const getUserPoints = (userId, params) => apiService.get(URIS_D('userPoints', userId), params)

export const listTransactions = (params) => apiService.get(URIS.points, { params })
export const createTransaction = (data) => apiService.post(URIS.points, data)

export const getPointById = (id) => apiService.get(URIS_D('point', id))
export const createPoint = (data) => apiService.post(URIS.points, data)
export const cancelPoint = (id, sourceSystem) => apiService.post(URIS_D('pointCancelBySalesId', id), { sales_id: id, source_system: sourceSystem })
export const setPointMaturity = (id) => apiService.post(URIS_D('pointSetMaturity', id), {})
export const batchPostPoints = (data) => apiService.post(URIS.adminBatchPost, data)
export const batchCancelPoints = (data) => apiService.post(URIS.adminBatchCancel, data)
export const calculatePointValue = (data) => apiService.post(URIS.publicCalculate, data)

const URIS_D = (url, param) => {
  return {
    user: `/v1/cms/user/users/${param}`,
    point: `/v1/cms/user/reward-points/${param}`,
    pointCancelBySalesId: `/v1/cms/user/reward-points/${param}/cancel`,
    pointSetMaturity: `/v1/cms/user/reward-points/${param}/set-maturity`,
    userBalance: `/v1/cms/user/reward-points/users/${param}/balance`,
    userPoints: `/v1/cms/user/reward-points/users/${param}/points`,
  }[url]
}

const URIS = {
  users: `/v1/cms/user/users`,
  points: `/v1/cms/user/reward-points`,
  publicCalculate: `/v1/reward-point-rules/calculate`,
  publicCalculateCash: `/v1/reward-cash-ratios/calculate-cash`,
  publicCalculateEncashable: `/v1/reward-encashment-rules/calculate-encashable-points`,
  publicValidateRedemption: `/v1/reward-encashment-rules/validate-redemption`,
  adminBatchPost: `/v1/cms/user/reward-points/batch-post`,
  adminBatchCancel: `/v1/cms/user/reward-points/batch-cancel`,
}
